<div class="modal-panel-tarefa">
  <div class="modal-header">
    <div class="modal-header-left">
      <div class="modal-icon">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="3 6 5 6 21 6" />
          <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
          <line x1="10" y1="11" x2="10" y2="17" />
          <line x1="14" y1="11" x2="14" y2="17" />
        </svg>
      </div>
      <div>
        <h2 class="modal-title">Descartar tarefa</h2>
        <p class="modal-subtitle">
          {{ sucessoDescarteTarefa ? 'Confirmação de descarte' : 'Confirme o descarte da tarefa' }}
        </p>
      </div>
    </div>
    <button
      class="btn-close"
      type="button"
      (click)="sucessoDescarteTarefa ? continuar() : onConfirmarDescarte(false)"
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18" />
        <line x1="6" y1="6" x2="18" y2="18" />
      </svg>
    </button>
  </div>

  <div class="modal-body modal-body--centered">
    <div class="status-content" *ngIf="confirmarDescarte">
      <span class="status-msg">Deseja realmente descartar esta tarefa?</span>
    </div>
    <div class="status-content" *ngIf="sucessoDescarteTarefa">
      <img
        [src]="BASE_IMG_URL + 'assets/img-ficha-obra/concluido.png'"
        alt="Sucesso"
        class="status-icon"
      />
      <span class="status-msg">Tarefa descartada com sucesso!</span>
    </div>
  </div>

  <div class="modal-footer" *ngIf="confirmarDescarte">
    <button class="btn-secondary" type="button" (click)="onConfirmarDescarte(false)">
      Não
    </button>
    <button class="btn-primary" type="button" (click)="onConfirmarDescarte(true)">
      Sim, descartar
    </button>
  </div>
  <div class="modal-footer" *ngIf="sucessoDescarteTarefa">
    <button class="btn-primary" type="button" (click)="continuar()">Continuar</button>
  </div>
</div>
